import React, {useState, useEffect} from "react";
import PropTypes from "prop-types";
import {markup} from "../../../utils/markup";

export default function CollapsedText(props) {
  const [isOpen, setIsOpen] = useState(false);
  const [loaded, setLoaded] = useState(false);
  const isLongHTML = props.html.length > props.maxCount;

  const toggle = () => {
    setIsOpen(!isOpen);
  };
  useEffect(() => {
    setLoaded(true);
  }, []);

  const cutHTML = (html, maxCount) => {
    return window.$(`<div>${html}</div>`).text().slice(0, maxCount);
  };
  const lessHTML =
    typeof window === `object` &&
    isLongHTML &&
    cutHTML(props.html, props.maxCount);
  return (
    <div>
      {isLongHTML && loaded && !isOpen ? (
        <p>
          {lessHTML}
          <button onClick={toggle}>...— развернуть</button>
        </p>
      ) : (
        <React.Fragment>
          <div dangerouslySetInnerHTML={markup(props.html)} />
          {isLongHTML && <button onClick={toggle}>свернуть</button>}
        </React.Fragment>
      )}
    </div>
  );
}
CollapsedText.propTypes = {
  maxCount: PropTypes.number,
  html: PropTypes.string
};
